const koreanRegex = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
const englishRegex = /[A-Z|a-z]/;
const numberRegex = /[0-9]/;

const sortOrder = [koreanRegex, englishRegex, numberRegex];

export const gapDefaultSort = function (a, b) {

  if((a === null || a === undefined) &&
     (b === null || b === undefined)){
    return 0;
  } else if ((a === null || a === undefined)) {
    return -1;
  } else if ((b === null || b === undefined)) {
    return 1;
  }

  if (typeof a === 'number' && typeof b === 'number') {
    return a === b ? 0 : a < b ? -1 : 1
  }

  const aString = a.toString();
  const bString = b.toString();

  let aSortingOrder = sortOrder.findIndex(regex => regex.test(aString[0]));
  let bSortingOrder = sortOrder.findIndex(regex => regex.test(bString[0]));

  if(aSortingOrder < 0) aSortingOrder = sortOrder.length;
  if(bSortingOrder < 0) bSortingOrder = sortOrder.length;

  return aSortingOrder === bSortingOrder ?
         (aString === bString ? 0 : aString < bString ? -1 : 1) :
         aSortingOrder < bSortingOrder ? -1 : 1;
}
